module.exports = __webpack_public_path__ + "img/nav-right-with-contact-honda.1de4a097.png";